<template>
  <div class="flex gap-2 items-center">
    <div>
      <printer-select />
    </div>
    <div>
      <b-btn variant="primary" size="sm" @click="$emit('printLink')">
        Print QR
      </b-btn>
    </div>
    <div>
      <b-btn variant="danger" size="sm" @click="$emit('delete')">
        Delete
      </b-btn>
    </div>
  </div>
</template>

<script>
const PrinterSelect = () => import('@/components/labels/PrinterSelect.vue');

export default {
  name: 'CompetitorActionButtons',
  components: {
    PrinterSelect,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
